import { useEffect, useState } from 'react';

/**
 * Front-layer ambient sparkles — 4 distinct "characters" that drift across the
 * viewport at different speeds and styles. Sits above the LuxeBackdrop but
 * below all interactive content (z-index 0, pointer-events: none).
 *
 * Disabled on touch / mobile / reduced-motion / admin pages.
 */
export default function Sparkles() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const small = window.matchMedia('(max-width: 768px)').matches;
    if (reduce || small) return;
    setEnabled(true);
  }, []);

  if (!enabled) return null;

  return (
    <div className="sparkles" aria-hidden data-testid="sparkles">
      {/* 1. Drifter — large slow gold */}
      <div className="sparkle sparkle--drifter" />
      {/* 2. Twinkler — tiny pulsing white */}
      <div className="sparkle sparkle--twinkler" />
      {/* 3. Curve-walker — medium gold, S-curve */}
      <div className="sparkle sparkle--curve" />
      {/* 4. Side-drifter — small green, horizontal */}
      <div className="sparkle sparkle--side" />
    </div>
  );
}
